import { useEffect, useState } from 'react';
import { ProductVariantType } from '../../../common/enums/common';
import { IColorVariant } from '../../../services/helper/productInterfaces';
import ProductColor from './productColor';
import useFavorite from './hooks/useFavorite';

export default function ProductVariants({
  variantType,
  variants,
  onSelectVariant,
  colorScheme,
  className,
  pageName
}: {
  variants: IColorVariant[];
  variantType: ProductVariantType;
  onSelectVariant: (variant: IColorVariant) => void;
  colorScheme: Record<string, Record<string, string>>;
  className: string;
  pageName?: string;
}) {
  const [selectedColor, setSelectedColor] = useState('');
  const { isFavoriteSelected } = useFavorite();

  useEffect(() => {
    setSelectedColor(variants?.[0]?.color);
  },[])

  useEffect(() => {
   if(pageName == 'Favorites') {
      const item = variants.find(variant => isFavoriteSelected(variant.sku));
      if(item) {
        setSelectedColor(item.color);
      }
    }
  },[])
  

  if (variantType === ProductVariantType.COLOR) {
    //variants.push(variants[0]);
    let showThreeDots = false;
    return (
      <div className={className} data-testid={'product-variants'}>
        
        {variants?.map((variant, index) => {
          if(index > 2) {
            if(showThreeDots) return;
            else
            {
              showThreeDots = true;
              return <span key={index} className="text-[#677083]">...</span>;
            }
          } else {
            const onVariantChange = (evt: any, color: string) => {
              evt.stopPropagation();
              if (color === selectedColor) return;
              setSelectedColor(color);
              onSelectVariant(variant);
            };
            return (
              <div
                key={index}
                className="flex justify-center items-center w-md xl:w-2md h-[20px] sm:h-[22px] md:h-[24px] xl:h-[28px]"
                data-testid={`product-variant-${index}`}
              >
                <ProductColor
                  handleVariant={onVariantChange}
                  color={variant.color}
                  isSelected={selectedColor === variant.color}
                  colorScheme={colorScheme}
                />
              </div>
            );
          }
        })}
      </div>
    );
  }
  return <></>;
}
